import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { getWindowProps } from '@Utils/window';

import type { ThreeUpView } from '../../common/MultiSectionView.types';
import { layoutThreeUpLandscape } from './ThreeUpLayoutLandscape';
import { layoutThreeUpPortrait } from './ThreeUpLayoutPortrait';

export const layoutThreeUp = async (params: {
  section: ThreeUpView;
  layoutTable: GridCard<PlaneTypes>[][];
}) => {
  if (getLayoutMode() === 'landscape') {
    layoutThreeUpLandscape(params);
    return;
  }

  return layoutThreeUpPortrait(params);
};

const getLayoutMode = (): 'landscape' | 'portrait' => {
  const { width, layoutMode } = getWindowProps();

  if (layoutMode === 'landscape' || width >= 1400) {
    return 'landscape';
  }

  return 'portrait';
};
